/**
 * Render one draggable dashboard widget type in the sidebar.
 */
Vue.asyncComponent('cms-dashboard-widget-type', {
    /**
     * Create the reactive state for this dashboard component.
     */
    data() {
        return {
            isActive: false,
        };
    },
    props: {
        name: {
            type: String,
        },
        nameDefault: {
            type: String,
            required: true,
        },
        description: {
            type: String,
        },
        type: {
            type: String,
            required: true,
        },
        preview: {
            type: String,
            required: false,
        },
        areChildrenAllowed: {
            type: Boolean,
            required: true,
        },
        icon: {
            type: String,
        },
    },
    computed: {
        /**
         * Prefer the explicit name and fall back to the default label.
         */
        currentName() {
            return this.name ? this.name : this.nameDefault;
        },
    },
    methods: {
        /**
         * Mark the widget type as active while dragging starts.
         */
        startDrag(event) {
            this.isActive = true;
            event.dataTransfer.dropEffect = 'move';
            event.dataTransfer.effectAllowed = 'move';

            this.$emit('dragstart');
        },
        /**
         * Clear the active drag state after dropping or canceling.
         */
        endDrag() {
            this.isActive = false;
            this.$emit('dragend');
        },
    },
}, 'cms/dashboard/editor/cms-dashboard-widget-type.html');
